import { graphql } from "@server/gql";

export default graphql(/* GraphQL */ `
  query AccountPageBySlug(
    $locale: String!
    $slug: String!
    $preview: Boolean
    $limit: Int!
  ) {
    pageCollection(
      locale: $locale
      where: { slug: $slug }
      limit: $limit
      preview: $preview
    ) {
      items {
        ...accountPage
      }
    }
  }
`);
